var $ = require('jquery');

$(function () {
    if ($('.1600-sliding-content-cards__carousel').length > 0)
    {
        var sliders = $('.1600-sliding-content-cards__carousel');
        var resizeTimeout;
        var isPageEditor = window.SitecoreUtilities.isPageEditor;
        if (!isPageEditor()) {
            sliders.each(function () {
                var slider = $(this);
                slider.slick({
                    arrows: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 2,
                    centerMode: false,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 2100,
                            settings: {
                                arrows: true,
                                slidesToShow: 1
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                arrows: false,
                                slidesToShow: 1
                            }
                        }
                    ],
                    rtl: window.GenericUtilities.isRTL()
                });

                //slider switches to full-width after the first successful slide transition
                slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    fullWidthAfterSlideTransition($(this), currentSlide, nextSlide, '.1600-sliding-content-cards__wrapper');
                });

                slider.on('afterChange', function (event, slick, currentSlide) {
                    nextArrowPositionCheck(slick);
                });
            }); //end sliders
            
            // to get slick slider to initialize on screen resize
            // https://github.com/kenwheeler/slick/issues/1730
            $(window).on('resize orientationchange', function () {
                window.clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    sliders.each(function() {
                        if ($(this)[0] && $(this)[0].slick) {
                            nextArrowPositionCheck($(this)[0].slick);
                        }
                    });
                }, 250);
            });

            if ($(window).width() <= 991) { //make all 1600 modules full width
                $('.1600-sliding-content-cards__container').parent().addClass('container-fluid').removeClass('container');
            }
        }
    }
});